export default function BudgetReports({year, status}) {
    return (
        <>
            <div>
                Budget reports in progress
            </div>
        </>
    )
}
